export default __webpack_public_path__ + "static/media/controlLinkOut24.153f7ff6.svg";